
import PullTo from 'vue-pull-to'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'

import {fetchOrder} from '@/api/order'
import {formatDate} from '@/utils/index'
import {mapGetters} from 'vuex'

export default {
computed: {
...mapGetters([
'taxonomyList'
]),
navbarSliderClass () {
if (this.activeIndex === 0) {
return 'weui-navbar__slider_0'
}
if (this.activeIndex === 1) {
return 'weui-navbar__slider_1'
}
if (this.activeIndex === 2) {
return 'weui-navbar__slider_2'
}
if (this.activeIndex === 3) {
return 'weui-navbar__slider_3'
}
}
},
data () {
return {
tabs: [
{
tabName: '全部订单',
orderStatus: ''
},
{
tabName: '待支付',
orderStatus: 'unpaid'
},
{
tabName: '发布中',
orderStatus: 'pending'
},
{
tabName: '已完成',
orderStatus: 'completed'
}
],
activeIndex: 0,
orderData: [],
page: 1
}
},
components: {
PullTo,
Tab,
TabItem,
Swipeout,
SwipeoutItem,
SwipeoutButton,
CheckIcon,
Sticky
},
methods: {
tabClick (idx) {
this.activeIndex = idx
this.getOrder()
},
getOrder (more) {
if (more === 'more') {
this.page++
} else {
this.page = 1
this.orderData = []
}
fetchOrder(this.tabs[this.activeIndex].orderStatus, this.page).then(resp => {
const orderData = resp.data.map(item => {
const createAt = formatDate(item.created_at) 
return {
...item,
created_at: createAt,
subject: item.items[0].subject
}
})
if (more === 'more') {
this.orderData = this.orderData.concat(orderData)
} else {
this.orderData = orderData
}
}).catch((e) => console.log('error', e))
}
},
mounted () {





if (this.$route.query.tab) {
this.activeIndex = parseInt(this.$route.query.tab)
}
this.getOrder()
}



}



// WEBPACK FOOTER //
// ./src/pages/order/index.vue